import store from '../store'
import Router from '../Router'
import { clientError, serverError, noConnectionError } from './notifications'

export default function ({ status, body }) {
	if (status == 400 && body.error == 'Unauthenticated.') {
		store.dispatch('auth/logout')
		Router.push('/login')
	}
	if (status > 400 && status < 500) {
		console.log('client Error')
		return store.dispatch('notifications/notifyError', 'client_error')
	}
	if (status >= 500) {
		console.log('server Error')
		return store.dispatch('notifications/notifyError', 'server_error')
	}
	if (status === 0) {
		return store.dispatch('notifications/notifyError', 'no_connection')
	}
}
